import { useFormik, FormikProvider } from "formik";
import { ICompany } from "../../../types/company.type";
import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";

type FormAccessData = {
  companyIds: string[];
  viewAll: boolean;
};

type FormProps = {
  onSubmit: (values: FormAccessData) => Promise<{
    ok: boolean;
    data: unknown;
    errors?: unknown[] | Record<string, unknown>;
  }>;
  data: FormAccessData;
  companyOptions: ICompany[];
  isSubmitting: boolean;
};

function FormCompanyAccess(props: FormProps) {
  const formik = useFormik({
    initialValues: props.data,
    enableReinitialize: true,
    onSubmit: async (data: FormAccessData) => {
      await props.onSubmit(data);
    },
  });

  const handleSelectAll = () => {
    const allIds = props.companyOptions.map((c) => c._id);
    formik.setFieldValue("companyIds", allIds);
  };

  const handleSelectNone = () => {
    formik.setFieldValue("companyIds", []);
  };

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="w-full h-full flex flex-col"
    >
      <FormikProvider value={formik}>
        <section className="flex-grow overflow-y-auto pr-0 sm:pr-2">
          <div className="mb-4 flex flex-col gap-2 sm:flex-row">
            <button
              type="button"
              onClick={handleSelectAll}
              className="rounded bg-red-600 px-3 py-2 text-sm text-white"
            >
              Selecionar Todos
            </button>
            <button
              type="button"
              onClick={handleSelectNone}
              className="rounded bg-gray-300 px-3 py-2 text-sm text-black"
            >
              Limpar Todos
            </button>
          </div>

          <div className="mb-4 border-y py-4">
            <label
              className="flex items-center gap-2 p-2 rounded cursor-pointer
                         font-semibold text-gray-800 hover:bg-gray-100 transition-colors duration-200"
            >
              <input
                type="checkbox"
                name="viewAll"
                checked={formik.values.viewAll}
                onChange={formik.handleChange}
                // Ajustes de estilo para o checkbox 'viewAll'
                className="w-5 h-5 text-red-600 bg-gray-100 border-gray-300
                           rounded-md border-2 focus:ring-red-500 focus:ring-2 focus:ring-offset-2
                           cursor-pointer transition-colors duration-200"
              />
              Visualizar Todas as Companhias
            </label>
            <p className="ml-7 text-sm text-gray-600 sm:ml-8">
              (Se marcado, este colaborador terá acesso a todas as companhias)
            </p>
          </div>

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3">
            {props.companyOptions
              .sort((a, b) =>
                (a.address?.city || "").localeCompare(b.address?.city || "")
              )
              .map((company) => {
                if (!company._id) return null;

                return (
                  <label
                    key={company._id}
                    className="flex min-w-0 items-center gap-2 rounded-lg p-2 cursor-pointer
                               hover:bg-gray-100 transition-colors duration-200"
                  >
                    <input
                      type="checkbox"
                      name="companyIds"
                      value={company._id}
                      checked={formik.values.companyIds.includes(company._id)}
                      onChange={formik.handleChange}
                      className="w-5 h-5 text-red-600 bg-gray-100 border-gray-300
                                 rounded-md border-2 focus:ring-red-500 focus:ring-2 focus:ring-offset-2
                                 cursor-pointer transition-colors duration-200"
                    />
                    <span className="break-words text-sm leading-5">
                      {company.address?.city || "N/A"}/
                      {company.address?.state || "UF"}
                    </span>
                  </label>
                );
              })}
          </div>
        </section>

        <div className="mt-4 flex w-full justify-end border-t border-gray-200 pt-4">
          <ButtonWithLoader
            className="button-with-loader mt-0 w-full sm:w-auto sm:min-w-[180px]"
            type="submit"
            isLoading={props.isSubmitting}
            disabled={props.isSubmitting}
          >
            Salvar Acessos
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  );
}

export default FormCompanyAccess;
